import React from 'react';
import {
  PaymentMethod as PaymentMethodModel,
} from '../../../structures/models/paymentMethod';

interface Props {
  paymentMethods: PaymentMethodModel[],
  openCreateForm: () => void,
  openEditForm: (paymentMethod: PaymentMethodModel) => void,
  isProcessing: boolean,
  showPaymentDeletion: (paymentMethod: PaymentMethodModel) => void,
}

const PaymentMethodsTable: React.FC<Props> = ({
  paymentMethods,
  openCreateForm,
  openEditForm,
  isProcessing,
  showPaymentDeletion,
}) => {
  return (
    <div>
      <div className="d-flex flex-row justify-content-between mb-2">
        <button
          className="btn btn-primary"
          onClick={openCreateForm}
          disabled={isProcessing}
        >
          Add New Card
        </button>
        {`${paymentMethods.length}/10`}
      </div>
      <table className="table">
        <thead className="thead-dark">
          <tr>
            <th scope="col">Card Number (last 4)</th>
            <th scope="col">Card Type</th>
            <th scope="col">Name</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          {paymentMethods.map((paymentMethod) => (
            <tr key={`payment-method-${paymentMethod.payment_method_id}`}>
              <th scope="row">
                <span>{paymentMethod.cc_number}</span>
              </th>
              <td>
                {paymentMethod.cc_type}
              </td>
              <td>
                {paymentMethod.name}
              </td>
              <td>
                <div className="btn-group rounded">
                  <button
                    className="btn btn-sm btn-outline-info"
                    disabled={isProcessing}
                    onClick={() => openEditForm(paymentMethod)}
                  >
                    Edit Card
                  </button>
                  <button
                    className="btn btn-sm btn-outline-danger"
                    disabled={isProcessing}
                    onClick={() => showPaymentDeletion(paymentMethod)}
                  >
                    Delete Card
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

  );
};

export default PaymentMethodsTable;
